import { ActionConstants } from '../constants/ActionConstants';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { GlobalHelper, ColorRGB } from '../utils/GlobalHelper';
import { UIHelper } from '../utils/UIHelper';
import { ProjectSettingsStore, ProjectSettingsStoreState, GroundType } from '../stores/ProjectSettingsStore';
import { SessionActions } from './SessionActions';
import { MeasurementUnitType } from '../stores/PersistentStore';

export abstract class ProjectSettingsActions {
    public static setGroundColor(groundColor: ColorRGB | null): void {
        if (groundColor == null) {
            return;
        }
        GlobalHelper.setFloorPlaneColor(groundColor);
        GlobalHelper.coreApp.viewer.requestRenderFrame();
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_GROUND_COLOR,
            value: groundColor
        });
    }

    public static showFloorPlan(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_FLOOR_PLAN,
            value: true
        });
        UIHelper.updateFloor();
    }

    public static hideFloorPlan(): void {
        if (ProjectSettingsStore.getFloorPlanVisibility()) {
            AppDispatcher.dispatch({
                actionType: ActionConstants.SET_FLOOR_PLAN,
                value: false
            });
            UIHelper.updateFloor();
        }
    }

    public static importState(state: ProjectSettingsStoreState): void {
        const updateLanguage: boolean = state.dataLanguage !== ProjectSettingsStore.getState().dataLanguage;
        AppDispatcher.dispatch({
            actionType: ActionConstants.IMPORT_PROJECT_SETTINGS,
            value: state
        });
        UIHelper.updateFloor();
        if (updateLanguage) {
            setTimeout(() => {
                SessionActions.setLanguage(ProjectSettingsStore.getState().dataLanguage);
            });
        }
    }

    public static setGroundType(value: GroundType): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_GROUND_TYPE,
            value: value
        });
        ProjectSettingsActions.hideFloorPlan();
        UIHelper.updateFloor();
    }

    public static setArticlePriceVisibility(show: boolean, persistent: boolean = false): void {
        AppDispatcher.dispatch({
            actionType: (
                persistent || !AppConfigurationStore.getState().twoStepSettingSaving ?
                    ActionConstants.SET_PRICE_VISIBLITY :
                    ActionConstants.SET_PRICE_VISIBLITY_TEMP
            ),
            value: (show ? 'show' : 'hide')
        });
    }

    public static setMeasurement(measurement: MeasurementUnitType, persistent: boolean = false): void {
        AppDispatcher.dispatch({
            actionType: (
                persistent || !AppConfigurationStore.getState().twoStepSettingSaving ?
                    ActionConstants.SET_MEASUREMENT :
                    ActionConstants.SET_MEASUREMENT_TEMP
            ),
            value: measurement
        });
        GlobalHelper.coreApp.i18n.setLengthUnit(ProjectSettingsStore.getLengthUnit());
    }

    public static setDataLanguage(pValue: string, persistent: boolean = false): void {
        AppDispatcher.dispatch({
            actionType: (
                persistent || !AppConfigurationStore.getState().twoStepSettingSaving ?
                    ActionConstants.SET_DATA_LANGUAGE :
                    ActionConstants.SET_DATA_LANGUAGE_TEMP
            ),
            value: pValue
        });
    }

    public static setCurrency(currency: string, persistent: boolean = false): void {
        AppDispatcher.dispatch({
            actionType: (
                persistent || !AppConfigurationStore.getState().twoStepSettingSaving ?
                    ActionConstants.SET_CURRENCY :
                    ActionConstants.SET_CURRENCY_TEMP
            ),
            value: currency
        });
    }

    /**
     * Writes current project-settings (price visibility, unit of measurement, datalanguage and currency) in PersistentStore,
     * so they will be used as default settings
     */
    public static saveSettings(): void {
        ProjectSettingsActions.setArticlePriceVisibility(ProjectSettingsStore.getState().articleListPrices === 'show', true);
        ProjectSettingsActions.setMeasurement(ProjectSettingsStore.getState().unitOfMeasurement, true);
        ProjectSettingsActions.setDataLanguage(ProjectSettingsStore.getState().dataLanguage, true);
        ProjectSettingsActions.setCurrency(ProjectSettingsStore.getState().currency, true);
    }

    /**
     * Gets default-Settings from PersistentStore and copies them in ProjectSettingsStore.
     *
     * Settings for: price-visibility, unit of measurement, data-language and currency
     */
    public static resetSettings(): void {
        ProjectSettingsActions.setArticlePriceVisibility(ProjectSettingsStore.getState().articleListPrices === 'show', false);
        ProjectSettingsActions.setMeasurement(ProjectSettingsStore.getState().unitOfMeasurement, false);
        ProjectSettingsActions.setDataLanguage(ProjectSettingsStore.getState().dataLanguage, false);
        ProjectSettingsActions.setCurrency(ProjectSettingsStore.getState().currency, false);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ProjectSettingsActions.ts